<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>
<script>
import theme from './theme.scss';

export default {
    name: 'flex-container',
    props: {
        center: Boolean,
        stretch: Boolean,
    },
    data() {
        return {
            theme,
        }
    },
    computed: {
        classes() {
            return {
                [theme.flex]: true,
                [theme.center]: this.center,
                [theme.stretch]: this.stretch,
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// FlexContainer.vue?cf757b72